var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('StreamBarcodeReader',{on:{"decode":(a, b, c) => _vm.onDecode(a, b, c),"loaded":() => _vm.onLoaded()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }